<template>
  <!-- banner -->
  <section v-if="bannerTopo != ''" class="hero-wrap hero-wrap-2"
    :style="{ backgroundImage: 'url(' + $imgURL + bannerTopo[0].insInstitucionalImagens[0].itgUrlImagem + ')' }">
    <div class="overlay"></div>
    <div class="container">
      <div class="row no-gutters slider-text align-items-end">
        <div class="pb-5">
          <h1 class="mb-0 bread">{{ bannerTopo[0].itiNome }}</h1>
        </div>
      </div>
    </div>
  </section>
  <!-- END banner -->

  <!-- empresa -->
  <section v-if="performance != ''" class="ftco-section ftco-about ftco-no-pt ftco-no-pb img">
    <div class="container">
      <div class="row d-flex">
        <div class="col-md-12 about-intro">
          <div class="row d-flex">
            <div class="col-md-6 d-flex align-items-stretch">
              <div class="img d-flex align-items-center align-self-stretch justify-content-center"
                :style="{ backgroundImage: 'url(' + $imgURL + performance[0].insInstitucionalImagens[0].itgUrlImagem + ')' }">
              </div>
            </div>
            <div class="col-md-6 pl-md-5 py-5">
              <div class="row justify-content-start pb-3 pt-md-5">
                <div class="col-md-12 heading-section ">
                  <span class="subheading">{{ performance[0].itiNome }}</span>
                  <h2 class="mb-4">{{ performance[0].itiReferencia }}</h2>
                  <p v-html="performance[0].itiResumo1"></p>
                  <div class="year-stablish d-flex">
                    <div class="icon2 d-flex align-items-center justify-content-center"><span
                        class="flaticon-light-bulb">{{ performance[0].itiCampoExtra3 }}</span></div>
                    <div class="text pl-4">
                      <strong class="number">{{ performance[0].itiCampoExtra1 }}</strong>
                      <span>{{ performance[0].itiCampoExtra2 }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- END empresa -->

  <!-- numeros -->
  <section v-if="numeros.length > 0" class="ftco-section ftco-counter img" id="section-counter" style="background-image:url('images/bg_4.jpg');">
    <div class="overlay"></div>
    <div class="container">
      <div class="row">

        <template v-for="numerosTxt in numeros" :key="numerosTxt.itiId">
          <div class="col-md-3 col-6 text-center">
            <div style="display: inline-flex; align-items: center; justify-content: center;">
              <VueJsCounter :start="0" :end="numerosTxt.itiNome" :duration="7000" class="number counter-wrap" style="
        font-weight: 700; font-size: 52px; color: #fff;" />
              <strong style="
        font-weight: 700; font-size: 52px; color: #fff;">{{ numerosTxt.itiCampoExtra1 }}</strong>
            </div><br>
            <span style="text-transform: uppercase;
        font-weight: 700; font-size: 18px; color: #fff;">{{ numerosTxt.itiReferencia }}</span>
          </div>
        </template>

      </div>
    </div>
  </section>
  <!-- END numeros -->

  <!-- missão, visão -->
  <section v-if="missaoVisao.length > 0" class="espaco100 ftco-section ftco-services"
    style="background-image: url('/images/use_your_illusion.png'); background-repeat: repeat;">
    <div class="row">
      <ul class="list">
        <li class="list-item" v-for="item in missaoVisao" :key="item.itiId" style="min-height: 500px;">
          <div class="list-item-content">
            <p class="list-item-titulo"> {{ item.itiNome }} </p>
          </div>
          <div class="list-item-texto">
            <p v-html="item.itiResumo1"></p>
          </div>
        </li>
      </ul>
    </div>
  </section>
  <!-- END missão, visão -->

  <!-- profissionais -->
  <section v-if="topoEquipe != ''" class="ftco-section espaco100">
    <div class="container">
      <div class="row no-gutters pb-5 justify-content-between">
        <div class="col-md-7 col-lg-6 heading-section ">
          <span class="subheading">{{ topoEquipe[0].itiNome }}</span>
          <h2 class="mb-4">{{ topoEquipe[0].itiReferencia }}</h2>
        </div>
      </div>
    </div>
    <!-- lista equipe -->
    <div v-if="listaEquipe !=''" class="container ">
      <div class="row no-gutters justify-content-center">
        <div v-for="membro in listaEquipe" :key="membro.itiId" class="col-md-4 col-lg  d-flex">
          <div class="staff">
            <div class="img-wrap d-flex align-items-stretch">
              <div class="img d-flex align-items-center"
                :style="{ backgroundImage: 'url(' + $imgURL + membro.insInstitucionalImagens[0].itgUrlImagem + ')' }">
                <div class="text w-100 pt-3 px-3 pb-4 text-center">
                  <h3>{{ membro.itiNome }}</h3>
                  <p><RouterLink :to="membro.itiCampoExtra1" class="btn btn-white">{{ membro.itiReferencia }}</RouterLink></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- END profissionais -->

</template>

<script>
import { useHead } from '@vueuse/head'
import axios from 'axios';

export default {
  name: 'EmpresaView',
  components: {

  },

  data: () => ({
    bannerTopo: [],
    missaoVisao: [],
    topoEquipe: [],
    listaEquipe: [],
    performance: [],
    numeros: [],
    numerosTxt: [],
    seoHome: [],
  }),

  methods: {
    textoLimpoSemHtml(value) {
      return value.replace(/<[^>]*>/g, '');
    },
    carregaMetas(titulo, texto, palavrasChave) {
      useHead({
        title: titulo,
        meta: [
          { name: "description", content: texto },
          { name: "author", content: "Performance Elevadores" },
          { httpEquiv: "Content-Language", content: "pt-BR" },
          { charset: "UTF-8" },
          { name: "robots", content: "index, follow" },
          { name: "keywords", content: palavrasChave },
        ],
      })
    },
  },

  created() {
  //aqui busca soluções
    axios.get('/Process/InsInstitucional/institucional/51/seosobre/0/x')
      .then(response => {
        this.seoHome = response.data;
         let seoHome0 = this.seoHome[0];
         seoHome0.itiResumo1 = this.textoLimpoSemHtml(seoHome0.itiResumo1);
         seoHome0.itiResumo2 = this.textoLimpoSemHtml(seoHome0.itiResumo2);

         this.carregaMetas(seoHome0.itiNome, seoHome0.itiResumo1, seoHome0.itiResumo2);
        //console.log('topo seo')
        //console.log(this.seoHome)
      })
      .catch(error => {
        console.error(error);
      });

    //aqui busca banner topo
    axios.get('/Process/InsInstitucional/institucional/11/sobretopo/0/x')
      .then(response => {
        this.bannerTopo = response.data;
        //console.log('topo banner')
        //console.log(this.bannerTopo)
      })
      .catch(error => {
        console.error(error);
      });
    //aqui busca banner topo
    axios.get('/Process/InsInstitucional/institucional/12/sobre/0/x')
      .then(response => {
        this.performance = response.data;
        //console.log('sobre performance')
        //console.log(this.performance)
      })
      .catch(error => {
        console.error(error);
      });
    //aqui busca imagem números
    axios.get('/Process/InsInstitucional/institucional/25/numerosimgfundo/0/x')
      .then(response => {
        this.numeros = response.data;
        //console.log('números')
        //console.log(this.numeros)
      })
      .catch(error => {
        console.error(error);
      });
      //aqui busca números
    axios.get('/Process/InsInstitucional/institucional/14/numeros/0/x')
      .then(response => {
        this.numeros = response.data;
        //console.log('números')
        //console.log(this.numeros)
      })
      .catch(error => {
        console.error(error);
      });
    //aqui busca missao visao
    axios.get('/Process/InsInstitucional/institucional/37/itenssobre/0/x')
      .then(response => {
        this.missaoVisao = response.data;
        //console.log('missão e visão')
        //console.log(this.missaoVisao)
      })
      .catch(error => {
        console.error(error);
      });
    //aqui busca topo equipe
    axios.get('/Process/InsInstitucional/institucional/38/topoequipe/0/x')
      .then(response => {
        this.topoEquipe = response.data;
        //console.log('topo equipe')
        //console.log(this.topoEquipe)
      })
      .catch(error => {
        console.error(error);
      });
    //aqui busca lista equipe
    axios.get('/Process/InsInstitucional/institucional/39/listaequipe/0/x')
      .then(response => {
        this.listaEquipe = response.data;
        //console.log('lista equipe')
        //console.log(this.listaEquipe)
      })
      .catch(error => {
        console.error(error);
      });

  },
}
</script>

<style scoped></style>